import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import vuex from "../store";

import ProcessoSeletivo from "../views/ProcessoSeletivo.vue";

Vue.use(VueRouter);
const TITLE_BASE = "exception jr - ";

const routes = [
  {
    path: "/",
    name: "home",
    meta: {
      title: TITLE_BASE + " desenvolvimento de software"
    },
    component: Home
  },
  {
    path: "/about",
    name: "about",
    meta: {
      title: TITLE_BASE + " sobre nós"
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../views/About.vue")
  },
  {
    path: "/services",
    name: "services",
    meta: {
      title: TITLE_BASE + "nossos serviços"
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../views/Services.vue")
  },
  {
    path: "/services/:slug",
    name: "service",
    component: () => import("../views/Service.vue")
  },
  {
    path: "/contacts",
    name: "contacts",
    meta: {
      title: TITLE_BASE + " contatos"
    },
    component: () => import("@/views/Contacts.vue")
  },
  {
    path: "/login",
    name: "login",
    meta: {
      title: TITLE_BASE + " entrar"
    },
    component: () => import("@/views/Login.vue")
  },
  // {
  //   path: "/admin",
  //   name: "admin",
  //   meta: {
  //     title: TITLE_BASE + " admin",
  //     requiresAuth: true
  //   },
  //   component: () => import("@/views/Admin/Index.vue")
  // },
  {
    path: "/admin/services",
    component: () => import("@/views/Admin/Services/Services.vue"),
    meta: {
      title: TITLE_BASE + " meus serviços"
    },
    children: [
      {
        path: "new",
        component: () => import("@/views/Admin/Services/NewService.vue"),
        meta: {
          title: TITLE_BASE + "novo serviço"
        }
      }
    ]
  },
  {
    path: "*",
    name: "EmConstrucao",
    meta: {
      title: TITLE_BASE + " em construção "
    },
    component: () => import("../views/EmConstrucao.vue")
  },

  {
    path: "/processoseletivo",
    name: "ProcessoSeletivo",
    meta: {
      title: TITLE_BASE + " processo seletivo"
    },
    component: ProcessoSeletivo
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes
});

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  await vuex.dispatch("fetchUser");

  const currentUser = vuex.state.user.loggedIn;

  console.log(vuex.state.user.loggedIn);
  document.title = to.meta.title;

  if (requiresAuth && !currentUser) {
    next("login");
  } else {
    next();
  }
  // next();
});
export default router;
